import React, { FC, useState } from 'react';
import { DropdownFolderList } from './list/DropdownFolderList';
import { FoldersDropdownChooseContainer } from './content-container/FoldersDropdownChooseContainer';
import { CreateNewFolderButton } from './create-button/CreateNewFolderButton';
import { FoldersDropdownCreate } from '../create-folder/FoldersDropdownCreate';

type Props = {
  onFolderSelect: Function;
  onFolderCreate: ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => void;
};

export const FoldersDropdownChoose: FC<Props> = ({
  onFolderSelect,
  onFolderCreate,
}) => {
  const [showCreate, setShowCreate] = useState(false);

  const showDropdownCreate = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setShowCreate(true);
  };

  return !showCreate ? (
    <>
      <FoldersDropdownChooseContainer>
        {/* 
          // @ts-ignore */}
        <DropdownFolderList onFolderSelect={onFolderSelect} />
      </FoldersDropdownChooseContainer>
      <CreateNewFolderButton
        showDropdownCreate={showDropdownCreate}
        onFolderCreate={onFolderCreate}
      />
    </>
  ) : (
    <FoldersDropdownCreate onFolderCreate={onFolderCreate} />
  );
};
